import Button from "./components/Button"
export default Button
